module.exports = __webpack_public_path__ + "static/media/Embargo on heavy water related activities.9ee8b9db.png";